module.exports = __webpack_public_path__ + "media/images/facebook-25cdccf3bc71d46cc547f3090b1690c5.png";